import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

/**
 * `@[asset:<assetId>]` pills. Their id is the asset, so the cover version is loaded directly.
 * A metadata pill that omitted `versionId` is not in this set and stays the static asset chip.
 */
const directAssetMonikerPills = new WeakSet<WorkspaceAgentMessagePill>();

export const markWorkspaceAgentDirectAssetMonikerPill = (pill: WorkspaceAgentMessagePill): void => {
  directAssetMonikerPills.add(pill);
};

export const isWorkspaceAgentDirectAssetMonikerPill = (pill: WorkspaceAgentMessagePill): boolean =>
  directAssetMonikerPills.has(pill);
